module.exports = "/_next/static/images/ss-1ba14435f8ee798577ecdda68eee7696.svg";